// Strict Portuguese validators — must match backend rules at /app/backend/server.py
// validate_pt_nif / validate_pt_phone

export const onlyDigits = (v) => String(v || '').replace(/\D/g, '');

/**
 * Validate a Portuguese NIF: 9 digits, prefix ∈ {1,2,3,5,9}, mod-11 checksum.
 * Empty/whitespace value is considered "ok" (optional field).
 * @returns {{ok: boolean, error: string, normalized: string}}
 */
export function validateNIF(value) {
  const v = String(value || '').trim();
  if (!v) return { ok: true, error: '', normalized: '' };
  const d = onlyDigits(v);
  if (d.length !== 9) return { ok: false, error: 'NIF deve ter 9 dígitos numéricos', normalized: d };
  if (!['1', '2', '3', '5', '9'].includes(d[0])) {
    return { ok: false, error: 'NIF deve começar por 1, 2, 3, 5 ou 9', normalized: d };
  }
  // mod-11 checksum
  let total = 0;
  for (let i = 0; i < 8; i++) total += parseInt(d[i], 10) * (9 - i);
  const rest = total % 11;
  const check = rest < 2 ? 0 : 11 - rest;
  if (check !== parseInt(d[8], 10)) {
    return { ok: false, error: 'NIF inválido (dígito de controlo incorreto)', normalized: d };
  }
  return { ok: true, error: '', normalized: d };
}

/**
 * Validate a Portuguese phone number. tipo ∈ {'telemovel', 'fixo'}.
 * Empty value is considered "ok".
 * - telemovel: 9 digits, starts with 9.
 * - fixo: 9 digits, starts with 2 (PT geographic) or 30 (VoIP).
 * @returns {{ok: boolean, error: string, normalized: string}}
 */
export function validatePhone(value, tipo = 'telemovel') {
  const v = String(value || '').trim();
  if (!v) return { ok: true, error: '', normalized: '' };
  const d = onlyDigits(v);
  if (d.length !== 9) return { ok: false, error: 'Telefone deve ter 9 dígitos numéricos', normalized: d };
  const t = (tipo || 'telemovel').toLowerCase();
  if (t === 'telemovel') {
    if (d[0] !== '9') return { ok: false, error: 'Telemóvel deve começar por 9', normalized: d };
  } else if (t === 'fixo') {
    if (!(d[0] === '2' || d.startsWith('30'))) {
      return { ok: false, error: 'Telefone fixo deve começar por 2 (geográfico) ou 30 (VoIP)', normalized: d };
    }
  } else {
    return { ok: false, error: `Tipo de telefone inválido: ${tipo}`, normalized: d };
  }
  return { ok: true, error: '', normalized: d };
}
